module.exports = " <div class=item thin-border> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/item.vue
// module id = 235
// module chunks = 0